import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COMOWELCOMEBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "display_points",
  "points_text"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  comoWelcomeBlockDescriptor: _generatedComoWelcomeBlockDescriptor,
  comoWelcomeBlockBlocDefinition,
  comoWelcomeBlockDashboardLayout,
  comoWelcomeBlockConfig,
  comoWelcomeBlockResolveConfig,
  comoWelcomeBlockProperties,
} = doodBlockConfig(
  {
    name: "Como - Welcome",
    componentType: 'ComoWelcomeBlockComponent',
    category: 'como',
    description: "Como - Welcome.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: "Bienvenue {{ firstname }},",
      options: {
        label: "pages.blocks.como-welcome.heading.label",
        help: "pages.blocks.como-welcome.heading.help",
        value: "Bienvenue {{ firstname }},",
      }
    }),
    display_points: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.como-welcome.display-points.label",
      }
    }),
    points_text: propertyValue({
      type: 'text',
      value: "Vous avez {{ points }} points",
      options: {
        label: "pages.blocks.como-welcome.points-text.label",
        help: "pages.blocks.como-welcome.points-text.help",
        value: "Vous avez {{ points }} points",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.como-welcome.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.como-welcome.fieldset.heading.label",
            fields: ["heading"],
          },
          {
            legend: "pages.blocks.como-welcome.fieldset.points.label",
            fields: [
              "display_points",
              {
                prop: "points_text",
                visibleWhen: { display_points: true },
              },
            ],
          },
        ],
      },
    ],
  })
);

export function comoWelcomeBlockDescriptor(): IBlockDescriptor;
export function comoWelcomeBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoWelcomeBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoWelcomeBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedComoWelcomeBlockDescriptor, comoWelcomeBlockProperties, fieldOrder);
}

export {
  comoWelcomeBlockBlocDefinition,
  comoWelcomeBlockDashboardLayout,
  comoWelcomeBlockProperties,
  comoWelcomeBlockConfig,
  comoWelcomeBlockResolveConfig,
};

export type ComoWelcomeBlockConfig = typeof comoWelcomeBlockConfig;
